module.exports = __webpack_public_path__ + "copy.svg?1793698113381";